import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { guideSteps } from '../../data/guideSteps';
import { SlideFrame } from '../deck/SlideFrame';
export function TitleSlide() {
  const reduce = useReducedMotion();
  return <SlideFrame tone="dark" data-id="element-254" data-mp="cbab3haijb57">
      <div className="flex h-full items-center" data-id="element-255" data-mp="c9z9no4jifh9">
        <div className="grid w-full grid-cols-12 items-center gap-[4cqw]" data-id="element-256" data-mp="7bnzfcac22yi">
          <div className="col-span-7" data-id="element-257" data-mp="79kxbtvwojdf">
            <p className="flex items-center gap-[0.8cqw] font-heading text-[1.3cqw] font-semibold uppercase tracking-[0.16em] text-mm-orange" data-id="element-258" data-mp="2c1m72ui8mpp">
              <span className="h-[0.8cqw] w-[0.8cqw] bg-mm-orange" aria-hidden="true" data-id="element-259" data-mp="3tje0na406m1x" />
              A step-by-step guide for Carolyn Hook
            </p>
            <h1 className="mt-[1.2cqw] font-heading text-[4.8cqw] font-bold leading-[1.02] tracking-tight text-mm-white" data-id="element-260" data-mp="1rs0yutxc0ua3">
              Finishing Leslie Outreach's Stripe Setup
            </h1>
            <div className="mt-[1.8cqw] h-[0.25cqw] w-[8cqw] bg-mm-orange" aria-hidden="true" data-id="element-261" data-mp="vrimohgwya6c" />
            <p className="mt-[1.8cqw] max-w-[44cqw] font-body text-[1.5cqw] leading-[1.4] text-mm-light-gray" data-id="element-262" data-mp="10q29sl78ts0a">
              Hi Carolyn! Most of the setup is already done. A few steps are left so Leslie
              Outreach can start receiving donations. Take your time. Each slide covers one step.
            </p>
            <p className="mt-[1.6cqw] flex items-center gap-[0.8cqw] font-body text-[1.2cqw] text-mm-light-gray" data-id="element-263" data-mp="1ehgseqx8nr6t">
              <span className="flex shrink-0 gap-[0.4cqw]" aria-hidden="true" data-id="element-264" data-mp="1jfi95576zef4">
                <span className="flex h-[2cqw] w-[2cqw] items-center justify-center bg-mm-orange text-mm-black" data-id="element-265" data-mp="15q83e6x2pol0">
                  <ChevronLeft className="h-[1.3cqw] w-[1.3cqw]" data-id="element-266" data-mp="19pyru3z4nsmd" />
                </span>
                <span className="flex h-[2cqw] w-[2cqw] items-center justify-center bg-mm-orange text-mm-black" data-id="element-267" data-mp="1xgchxoy5jheb">
                  <ChevronRight className="h-[1.3cqw] w-[1.3cqw]" data-id="element-268" data-mp="2284dkdw60dbb" />
                </span>
              </span>
              Click the orange arrows on the left and the right or press your arrow keys to go to
              the next or previous section.
            </p>
          </div>

          <div className="mm-cap col-span-5 border-2 border-mm-muted-charcoal bg-[#141414] p-[2cqw]" data-id="element-269" data-mp="231tv8735wk6z">
            <p className="font-heading text-[1.15cqw] font-semibold uppercase tracking-[0.16em] text-mm-light-gray" data-id="element-270" data-mp="1y4bngk0vsb0k">
              {guideSteps.length} steps · about 20 minutes
            </p>
            <ol className="mt-[1cqw]" data-id="element-271" data-mp="1odgwx3glqp9b">
              {guideSteps.map((step, index) => <motion.li key={step.number} className="flex items-baseline gap-[1.4cqw] border-t border-mm-muted-charcoal py-[0.7cqw]" initial={reduce ? false : {
              opacity: 0,
              y: 8
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.35,
              delay: 0.1 + index * 0.05,
              ease: 'easeOut'
            }} data-id="element-272" data-mp="1kblzia1skw0t" data-mpi={index}>
                  <span className="font-heading text-[1.5cqw] font-bold text-mm-orange" data-id="element-273" data-mp="vbfuxarqsnol">
                    {String(step.number).padStart(2, '0')}
                  </span>
                  <span className="font-body text-[1.4cqw] text-mm-white" data-id="element-274" data-mp="10bu08l1yljix">{step.title}</span>
                </motion.li>)}
            </ol>
          </div>
        </div>
      </div>
    </SlideFrame>;
}